import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const sapBdcDatasetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.sapBdc.datasetType,
    displayName: stringResources.Mirror_SAP_BDC_Inbound_header,
    supportLinkedServiceTypes: [adfModelTypeMap.sapBdc.linkedServiceType],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    icon: {
        className: 'svg-i-100x100-Sap'
    },
    isFirstClass: true,
    category: ['Database'],
    supportDataFlowSource: false,
    supportDataFlowSink: false,
    notSupportCopy: true,
    notSupportLookupActivity: true
};
